import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * A grey placeholder block for skeletons (see src/skeletons/README.md). Size it with a class from the skeleton's
 * own SCSS. With a `slot`, the worker can fill it with text per request (e.g. the product name); once it has
 * content it stops being grey.
 */
export default function SkeletonBlock({ className, slot, tag: Tag, text }) {
  return (
    <Tag
      className={classNames('SkeletonBlock', { 'SkeletonBlock--text': text }, className)}
      data-skeleton-slot={slot || undefined}
    />
  );
}

SkeletonBlock.propTypes = {
  className: PropTypes.string,
  slot: PropTypes.string,
  tag: PropTypes.string,
  text: PropTypes.bool,
};

SkeletonBlock.defaultProps = {
  className: '',
  slot: '',
  tag: 'div',
  text: false,
};
